<template>
  <a-config-provider :locale="zhCN">
    <a-style-provider hash-priority="high" :transformers="[legacyLogicalPropertiesTransformer]">
      <router-view/>
    </a-style-provider>
  </a-config-provider>
</template>
<script setup>
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import { resetTheme } from "@/utils/theme";
  import { onMounted } from "vue";
  import { legacyLogicalPropertiesTransformer } from 'ant-design-vue';
  onMounted(() => {
    resetTheme()
  })
</script>
